export default {
    mode: {
        "BASE": "基础检测",
        "COMPREHENSIVE": "全面检测",
        "EVALUATE": "评估检测",
    },
    gearbox_type: {
        "AUTO": "自动",
        "MANUAL": "手动",
    },
    vehicle_use: {
        "NON_OPERATION": "非运营",
        "OPERATION": "运营",
        "OPERATION_TO_NON": "营转非",
    },
    nature_of_use: {
        "PERSONAL": "个人",
        "ENTERPRISE": "企业",
    },
    vehicle_source: {
        "DOMESTIC": "国产",
        "IMPORT": "进口",
        "JOINT_VENTURE": "合资",
    },
    inspector_level: {
        "Primary": "初级",
        "Intermediate": "中级",
        "Advanced": "高级",
        "Top": "最高级",
    }
}